var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 376.112,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 10000 9951",
    width: "100mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1210 0h7580c666 0 1210 545 1210 1210v7531c0 666-545 1210-1210 1210H1210C544 9951 0 9406 0 8741V1210C0 544 545 0 1210 0zm-130 4097h999c-104 303-161 627-161 965 0 1667 1380 3018 3082 3018s3082-1351 3082-3018c0-337-57-662-161-965h999v4190c0 297-243 539-539 539H1578c-274 0-498-224-498-498zM7274 986h1161c262 0 477 215 477 477v1079c0 262-215 477-477 477H7274c-262 0-477-215-477-477V1463c0-262 215-477 477-477zM5003 2936c1105 0 2001 878 2001 1960s-896 1960-2001 1960-2001-878-2001-1960 896-1960 2001-1960z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon1);
export default __webpack_public_path__ + "static/media/instagram-icon-1.2711f7dcfc1da0a3d4dd2bdc8764a525.svg";
export { ForwardRef as ReactComponent };